import ReactBreadcrumb from "@/components/breadcrumb/Breadcrumb";
import Notification from "@/dashboard/components/preference/Notification";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const Preference = () => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "notification",
  });
  const { module } = useParams<{ module: string }>();

  const bcs = [{ href: "", name: t("Mes préférences") }];

  if (module === "notification") {
    bcs.push({
      href: "",
      name: t("Notification"),
    });
  }

  return (
    <div>
      <ReactBreadcrumb items={bcs} />

      {module === "notification" && <Notification />}
    </div>
  );
};

export default Preference;
